import { makeStyles, Tooltip } from '@fluentui/react-components';

const useStyles = makeStyles({
  dot: {
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    display: 'inline-block',
    cursor: 'default',
  },
  connected: {
    backgroundColor: '#0e9e0e',
  },
  disconnected: {
    backgroundColor: '#d13438',
  },
});

const AlertHealthIndicator = ({ isConnected }) => {
  const styles = useStyles();

  return (
    <Tooltip
      content={isConnected ? "Système d'alertes connecté" : "Système d'alertes déconnecté"}
      relationship="label"
    >
      <span
        className={`${styles.dot} ${isConnected ? styles.connected : styles.disconnected}`}
        role="status"
        aria-label={isConnected ? "Système d'alertes connecté" : "Système d'alertes déconnecté"}
      />
    </Tooltip>
  );
};

export default AlertHealthIndicator;
